import { convertFieldValueAvroToJson } from 'rpc-client-utils';

/**
 * Converts a record of CHIRP FieldValue Avro entries to plain JSON.
 * Each value is recursively unwrapped from its Avro envelope (e.g. MapFieldValue, StringFieldValue)
 */
export const convertChirpFieldOverridesToJson = raw => {
  const result = {};
  for (const [key, fieldValue] of Object.entries(raw)) {
    result[key] = convertFieldValueAvroToJson(fieldValue);
  }
  return result;
};
export const convertChirpValueToJson = chirpValue => {
  if (!chirpValue || typeof chirpValue !== 'object') return chirpValue;
  if (chirpValue['@type']) {
    return convertChirpValueToJson(chirpValue.value);
  }
  if (Array.isArray(chirpValue)) {
    return chirpValue.map(convertChirpValueToJson);
  }
  const jsonValue = {};
  Object.keys(chirpValue).forEach(key => {
    jsonValue[key] = convertChirpValueToJson(chirpValue[key]);
  });
  return jsonValue;
};

// Largely taken from https://github.com/HubSpotEngineering/rpc-client-utils/blob/master/rpc-client-utils/static/js/internal/fieldValueConverter.ts#L63
// But using jackson @type notation instead of long type names
export function convertJsonToJacksonFieldValueAvro(jsonValue) {
  if (jsonValue === null || jsonValue === undefined) {
    return {
      '@type': 'null'
    };
  }
  const type = typeof jsonValue;
  if (type === 'string') {
    return {
      '@type': 'string',
      value: jsonValue
    };
  }
  if (type === 'number') {
    // Determine if the number is an integer or floating point
    if (Number.isInteger(jsonValue) && jsonValue <= 2147483647 && jsonValue >= -2147483648) {
      return {
        '@type': 'integer',
        value: jsonValue
      };
    } else if (Number.isInteger(jsonValue)) {
      return {
        '@type': 'long',
        value: jsonValue
      };
    } else {
      return {
        '@type': 'double',
        value: jsonValue
      };
    }
  }
  if (type === 'boolean') {
    return {
      '@type': 'boolean',
      value: jsonValue
    };
  }
  if (Array.isArray(jsonValue)) {
    return {
      '@type': 'list',
      value: jsonValue.map(item => convertJsonToJacksonFieldValueAvro(item))
    };
  }
  if (type === 'object') {
    const avroObject = {};
    const objValue = jsonValue;
    for (const key in objValue) {
      if (Object.prototype.hasOwnProperty.call(objValue, key)) {
        avroObject[key] = convertJsonToJacksonFieldValueAvro(objValue[key]);
      }
    }
    return {
      '@type': 'map',
      value: avroObject
    };
  }

  // Default fallback for unsupported types
  return {
    '@type': 'null'
  };
}